import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";

export const RESEARCH_DESCRIPTION = "Explore Aon's ratings and analysis on your managers and strategies.";

export const HomeResearch: React.FunctionComponent = () => {
    const navigate = useNavigate();

    return (
        <div
            className="home__resource-card"
            onClick={() => navigateTo("/research", navigate)}
            data-testid="home-research__container"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    navigateTo("/research", navigate);
                }
            }}
        >
            <div className="home__resource-card-header">
                <div className="home__resource-card-icon home__resource-card-icon--research">
                    <i className="fa-light fa-magnifying-glass" />
                </div>
                <h3 className="home__resource-card-title" data-testid="home-research__title">
                    {getTranslation("subnav.researchItem", "Research")}
                </h3>
            </div>
            <p className="home__resource-card-description">
                {getTranslation("home.research.description", RESEARCH_DESCRIPTION)}
            </p>
        </div>
    );
};
